module.exports = __webpack_public_path__ + "static/img/sevenBox.47bdef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sevenBox.png
// module id = Zp7S
// module chunks = 1